"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const MemberWorkIdentifierTooltip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: "When searching by 'Member Work Identifier' you are not able to add any other search criteria." }));
exports.default = MemberWorkIdentifierTooltip;
